import ReactDOM from "react-dom";
import App from "./app";
import { inject } from "@vercel/analytics";

inject();

const app = document.getElementById("app");
ReactDOM.render(<App />, app);
